<template>
  <b-modal
    id="modal-personal"
    ref="modal-personal"
    size="xl"
    title="เพิ่มข้อมูล"
    @ok="onSubmit"
  >
    <b-row>
      <b-col md="3">
        <b-form-group
          label="เลขบัตรประชาชน"
          label-for="identity"
        >

          <b-form-input
            id="identity"
            v-model="personal.identity"
            placeholder="เลขบัตรประชาชน"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="ชื่อ"
          label-for="name"
        >

          <b-form-input
            id="name"
            v-model="personal.name"
            placeholder="ชื่อ"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="นามสกุล"
          label-for="lastname"
        >

          <b-form-input
            id="lastname"
            v-model="personal.lastname"
            placeholder="นามสกุล"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="วันเดือนปี เกิด"
          label-for="dateOfBirth"
        >

          <b-form-input
            id="dateOfBirth"
            v-model="personal.dateOfBirth"
            placeholder="วันเดือนปี เกิด"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="ที่อยู่"
          label-for="address"
        >

          <b-form-textarea
            id="address"
            v-model="personal.address"
            placeholder="ที่อยู่"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="ตำบล"
          label-for="tumbol"
        >

          <b-form-input
            id="tumbol"
            v-model="personal.tumbol"
            placeholder="ตำบล"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="อำเภอ"
          label-for="ampher"
        >

          <b-form-input
            id="ampher"
            v-model="personal.ampher"
            placeholder="อำเภอ"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="จังหวัด"
          label-for="province"
        >

          <b-form-input
            id="province"
            v-model="personal.province"
            placeholder="จังหวัด"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="รหัสไปรษณีย์"
          label-for="zipcode"
        >

          <b-form-input
            id="zipcode"
            v-model="personal.zipcode"
            placeholder="รหัสไปรษณีย์"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="เบอร์โทรศัพท์"
          label-for="mobile"
        >

          <b-form-input
            id="mobile"
            v-model="personal.mobile"
            placeholder="เบอร์โทรศัพท์"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="อีเมล"
          label-for="email"
        >

          <b-form-input
            id="email"
            v-model="personal.email"
            placeholder="อีเมล"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="LineID"
          label-for="line"
        >

          <b-form-input
            id="line"
            v-model="personal.line"
            placeholder="LineID"
          />
        </b-form-group>
      </b-col>

      <b-col
        md="3"
        class="d-flex justify-content-center"
      >
        <b-button
          variant="outline-primary"
        >
          อ่านข้อมูลจากบัตร
        </b-button>
      </b-col>

    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,

} from 'bootstrap-vue'

import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
  },
  props: {
    personal: {
      type: Object,
    },
  },
  // data() {
  //   return {
  //     personal: {
  //       id: 1,
  //       identity: '000000000000',
  //       title: 'title',
  //       name: 'male',
  //       lastname: 'designer',
  //       sex: 'sex',
  //       dateofbirth: 'dateofbirth',
  //       address: 'address',
  //       tumbon: 'tumbon',
  //       ampher: 'ampher',
  //       province: 'province',
  //       zipcode: 'zipcode',
  //       tel: 'tel',
  //       mobile: 'mobile',
  //       email: 'email',
  //       line: 'line',
  //     },
  //   }
  // },
  created() {
    console.log('created', this)
  },
  methods: {
    onSubmit() {
      this.$emit('handle-submit', this.personal)
    },
  },
}
</script>

<style>

</style>
